import { render, staticRenderFns } from "./plan-record.vue?vue&type=template&id=88812a34&scoped=true&"
import script from "./plan-record.vue?vue&type=script&lang=js&"
export * from "./plan-record.vue?vue&type=script&lang=js&"
import style0 from "./plan-record.vue?vue&type=style&index=0&id=88812a34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88812a34",
  null
  
)

export default component.exports